export function mobileMenu() {
	const $body = $("body");
	$(".menu-burger").on("click", function () {
		$body.toggleClass("menu-open");
	});

	$('.menu-item-has-children').on("click", function () {
		$(this).toggleClass("open-sub-menu");
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileMenu.js